<template>
  <b-modal
    id="OtpAuthAppliedMessageModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="onOkay"
    ref="OtpAuthAppliedMessageModal"
  >
    <div class="text-center">
      <div>
        <p class="vp-font-weight-700 vp-font-size-17 header-font">
          Security Policy Updated
        </p>
      </div>

      <div class="vp-width-416">
        <p class="vp-font-size-16 content">
          Adding an extra layer of security is compulsory by the dashboard
          admins for you to access. To continue, please enable Two
          step-authentication in your VisiPoint Passport account.
        </p>
      </div>

      <hr class="vertical-line" />

      <div>
        <button class="confirm-btn" @click="onOkay()" size="md">
          <span class="vp-font-size-16 btn-text">Okay</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      isSubmitted: false,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("dailyLogbook", ["resetState"]),
    ...mapActions("authfack", [
      "fetchUserOtpAuthStatus",
      "sendOtpAuthCode",
      "updateUserOtpAuthStatus",
    ]),
    onOkay() {
      window.location.href = `${process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT}?force_otp=1`;
    },
  },
  beforeMount() {
    this.resetState();
  },
};
</script>

<style lang="scss">
#OtpAuthAppliedMessageModal___BV_modal_content_ {
  #OtpAuthAppliedMessageModal___BV_modal_body_ {
    padding: 40px 42px 24px !important;
  }
  border-radius: 26px;
  width: 500px !important;
  div p,
  span {
    color: #4a4a4a;
    margin-bottom: 40px;
  }
  .header-font {
    color: #000000 !important;
    height: 12px;
    line-height: 16px;
  }
  .content {
    letter-spacing: 0.25px;
    line-height: 24px;
    font-weight: 400;
  }
  .confirm-btn {
    width: 112px;
    height: 32px;
    gap: 0px;
    background-color: #103f5e;
    border: none;
    border-radius: 16px;
  }
  .btn-text {
    color: #ffffff;
  }
  .vertical-line {
    border-top: 1px solid #ebebeb;
    margin: 0 0 24px 0;
  }
  .contact_email {
    color: #2680eb;
    text-decoration: underline;
    font-weight: 700;
  }
}
</style>
